import { render, staticRenderFns } from "./clientesBluesend.vue?vue&type=template&id=27c96c6f&scoped=true"
import script from "./clientesBluesend.vue?vue&type=script&lang=js"
export * from "./clientesBluesend.vue?vue&type=script&lang=js"
import style0 from "./clientesBluesend.vue?vue&type=style&index=0&id=27c96c6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c96c6f",
  null
  
)

export default component.exports